"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function geoFact(name, geo) {
    return {
        name,
        tableType: 'fact',
        grain: [],
        tableGrain: [
            '!' + geo,
            'year_key',
        ],
        foreignKeys: [
            geo + '::key',
        ]
    };
}
const cbsa = {
    name: 'cbsa',
    tableType: 'dim',
    grain: [],
    tableGrain: ['!cbsa', 'year_key'],
    foreignKeys: [],
    facts: [
        'cbsa-age-sex',
        'cbsa-census',
        'cbsa-financial',
        'cbsa-pophealth',
        'cbsa-race-ethnicity',
        'cbsa-market-concentration',
        'hcg-metrics-msa',
        'brfss',
        'aco-cbsa',
        'health-system-market-share-cbsa',
        'race-ethnicity-proportions-cbsa',
        'ma-contract-plan-type-cbsa',
        'ma-payer-group-cbsa',
        'hospital-market-share-cbsa',
        'patient-panel-msa-age-band-ranked',
        'patient-panel-msa-hcpcs-ranked',
        'patient-panel-msa-icd-ranked',
        'patient-panel-msa-mr-line-ranked',
        'patient-panel-msa-pos-ranked',
        'patient-panel-msa-summary'
    ]
};
const country = {
    name: 'country',
    tableType: 'dim',
    grain: [],
    tableGrain: ['!country'],
    foreignKeys: [],
    facts: [
        'common-core-benchmarks-metrics-national',
        'common-core-benchmarks-percentile-national',
        'common-core-benchmarks-revisits-national',
        'national-episodes-of-care-by-drg-group',
        'crm-national',
        'hcg-metrics-national'
    ]
};
const congressionalDistrict = {
    name: 'congressional-district',
    tableType: 'dim',
    grain: [],
    tableGrain: [
        '!congressional-district',
        'year_key'
    ],
    foreignKeys: [],
    facts: []
};
const cbsaAgeSex = geoFact('cbsa-age-sex', 'cbsa');
const cbsaCensus = geoFact('cbsa-census', 'cbsa');
const cbsaFinancial = geoFact('cbsa-financial', 'cbsa');
const cbsaPophealth = geoFact('cbsa-pophealth', 'cbsa');
const cbsaRaceEthnicity = geoFact('cbsa-race-ethnicity', 'cbsa');
const county = {
    name: 'county',
    tableType: 'dim',
    grain: [],
    tableGrain: ['!county', 'year_key'],
    foreignKeys: [],
    facts: [
        'county-age-sex',
        'county-census',
        'county-financial',
        'county-pophealth',
        'county-race-ethnicity',
        'county-market-concentration',
        'medicare-geographic-variation',
        'apm-metrics',
        'aco-county',
        'health-system-market-share-county',
        'race-ethnicity-proportions-county',
        'ma-contract-plan-type-county',
        'ma-payer-group-county',
        'hospital-market-share-county'
    ]
};
const countyAgeSex = geoFact('county-age-sex', 'county');
const countyCensus = geoFact('county-census', 'county');
const countyFinancial = geoFact('county-financial', 'county');
const countyPophealth = geoFact('county-pophealth', 'county');
const countyRaceEthnicity = geoFact('county-race-ethnicity', 'county');
const state = {
    name: 'state',
    tableType: 'dim',
    grain: [],
    tableGrain: ['!state'],
    foreignKeys: [],
    facts: [
        'state-age-sex',
        'state-census',
        'state-financial',
        'state-pophealth',
        'state-race-ethnicity',
        'hcg-metrics-state',
        'aco-state',
        'health-system-market-share-state',
        'race-ethnicity-proportions-state',
        'ma-contract-plan-type-state',
        'ma-payer-group-state',
        'hospital-market-share-state'
    ],
};
const stateAgeSex = geoFact('state-age-sex', 'state');
const stateCensus = geoFact('state-census', 'state');
const stateFinancial = geoFact('state-financial', 'state');
const statePophealth = geoFact('state-pophealth', 'state');
const stateRaceEthnicity = geoFact('state-race-ethnicity', 'state');
const nationalEpisodesOfCareByDrgGroup = geoFact('national-episodes-of-care-by-drg-group', 'country');
const zcta = {
    name: 'zcta',
    tableType: 'dim',
    grain: [],
    tableGrain: ['!zcta', 'year_key'],
    foreignKeys: [],
    facts: [
        'zcta-age-sex',
        'zcta-census',
        'zcta-financial',
        'zcta-pophealth',
        'zcta-race-ethnicity',
    ]
};
const zctaAgeSex = geoFact('zcta-age-sex', 'zcta');
const zctaCensus = geoFact('zcta-census', 'zcta');
const zctaFinancial = geoFact('zcta-financial', 'zcta');
const zctaPophealth = geoFact('zcta-pophealth', 'zcta');
const zctaRaceEthnicity = geoFact('zcta-race-ethnicity', 'zcta');
const hcgMetricsMSA = geoFact('hcg-metrics-msa', 'cbsa');
const hcgMetricsState = geoFact('hcg-metrics-state', 'state');
const hcgMetricsNational = geoFact('hcg-metrics-national', 'country');
exports.default = [
    cbsa,
    cbsaAgeSex,
    cbsaCensus,
    cbsaFinancial,
    cbsaPophealth,
    cbsaRaceEthnicity,
    congressionalDistrict,
    county,
    countyAgeSex,
    countyCensus,
    countyFinancial,
    countyPophealth,
    countyRaceEthnicity,
    state,
    stateAgeSex,
    stateCensus,
    stateFinancial,
    statePophealth,
    stateRaceEthnicity,
    zcta,
    zctaAgeSex,
    zctaCensus,
    zctaFinancial,
    zctaPophealth,
    zctaRaceEthnicity,
    hcgMetricsMSA,
    hcgMetricsState,
    hcgMetricsNational,
    country,
    nationalEpisodesOfCareByDrgGroup
];
